"use strict";
/********************************************************************************
  THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND

  HxObjectSerializer.ts

  Generating File: ObjectSerializerJs.tt

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxRoot_1 = __importDefault(require("./HxRoot"));
var HxError_1 = __importDefault(require("./HxError"));
var HxPreferences_1 = __importDefault(require("./HxPreferences"));
var HxUnifiedMailbox_1 = __importDefault(require("./HxUnifiedMailbox"));
var HxAccount_1 = __importDefault(require("./HxAccount"));
var HxMailAccountData_1 = __importDefault(require("./HxMailAccountData"));
var HxCalendarAccountData_1 = __importDefault(require("./HxCalendarAccountData"));
var HxView_1 = __importDefault(require("./HxView"));
var HxConversationHeader_1 = __importDefault(require("./HxConversationHeader"));
var HxSuggestion_1 = __importDefault(require("./HxSuggestion"));
var HxPerson_1 = __importDefault(require("./HxPerson"));
var HxMeetingRequest_1 = __importDefault(require("./HxMeetingRequest"));
var HxMeetingResponse_1 = __importDefault(require("./HxMeetingResponse"));
var HxMeetingCancellation_1 = __importDefault(require("./HxMeetingCancellation"));
var HxTimeZoneSystemEvent_1 = __importDefault(require("./HxTimeZoneSystemEvent"));
var HxCalendarRoot_1 = __importDefault(require("./HxCalendarRoot"));
var HxWeatherData_1 = __importDefault(require("./HxWeatherData"));
var HxPhotoData_1 = __importDefault(require("./HxPhotoData"));
var HxCalendarGroupData_1 = __importDefault(require("./HxCalendarGroupData"));
var HxCalendarData_1 = __importDefault(require("./HxCalendarData"));
var HxCategoryData_1 = __importDefault(require("./HxCategoryData"));
var HxAppointmentHeader_1 = __importDefault(require("./HxAppointmentHeader"));
var HxAppointmentBody_1 = __importDefault(require("./HxAppointmentBody"));
var HxMeetingAttendee_1 = __importDefault(require("./HxMeetingAttendee"));
var HxRightsManagementLicense_1 = __importDefault(require("./HxRightsManagementLicense"));
var HxSmimeInformation_1 = __importDefault(require("./HxSmimeInformation"));
var HxCalendarAttendeeCollectionPair_1 = __importDefault(require("./HxCalendarAttendeeCollectionPair"));
var HxRmsTemplate_1 = __importDefault(require("./HxRmsTemplate"));
var HxPhotoInfo_1 = __importDefault(require("./HxPhotoInfo"));
var HxWeatherUpdates_1 = __importDefault(require("./HxWeatherUpdates"));
var HxCalendarCatalog_1 = __importDefault(require("./HxCalendarCatalog"));
var HxCalendarCatalogItem_1 = __importDefault(require("./HxCalendarCatalogItem"));
var HxGlobalApplicationSettings_1 = __importDefault(require("./HxGlobalApplicationSettings"));
var HxTileNotification_1 = __importDefault(require("./HxTileNotification"));
var HxNotificationData_1 = __importDefault(require("./HxNotificationData"));
var HxMailToastData_1 = __importDefault(require("./HxMailToastData"));
var HxCalendarNotificationData_1 = __importDefault(require("./HxCalendarNotificationData"));
var HxHolidayCatalog_1 = __importDefault(require("./HxHolidayCatalog"));
var HxHolidayCatalogData_1 = __importDefault(require("./HxHolidayCatalogData"));
var HxConversation_1 = __importDefault(require("./HxConversation"));
var HxViewLink_1 = __importDefault(require("./HxViewLink"));
var HxRichContent_1 = __importDefault(require("./HxRichContent"));
var HxMessageHeader_1 = __importDefault(require("./HxMessageHeader"));
var HxMessageData_1 = __importDefault(require("./HxMessageData"));
var HxRecipient_1 = __importDefault(require("./HxRecipient"));
var HxContact_1 = __importDefault(require("./HxContact"));
var HxContactAddress_1 = __importDefault(require("./HxContactAddress"));
var HxContactDate_1 = __importDefault(require("./HxContactDate"));
var HxContactPhone_1 = __importDefault(require("./HxContactPhone"));
var HxContactSignificantOther_1 = __importDefault(require("./HxContactSignificantOther"));
var HxLocationEntityData_1 = __importDefault(require("./HxLocationEntityData"));
var HxLocationSuggestionsData_1 = __importDefault(require("./HxLocationSuggestionsData"));
var HxContactAccountData_1 = __importDefault(require("./HxContactAccountData"));
var HxContactSyncState_1 = __importDefault(require("./HxContactSyncState"));
var HxContactSearchData_1 = __importDefault(require("./HxContactSearchData"));
var HxEasPolicies_1 = __importDefault(require("./HxEasPolicies"));
var HxContactUrl_1 = __importDefault(require("./HxContactUrl"));
var HxMeetingRequestOccurrenceInfo_1 = __importDefault(require("./HxMeetingRequestOccurrenceInfo"));
var HxCatalogDataProvider_1 = __importDefault(require("./HxCatalogDataProvider"));
var HxSharingMessageAction_1 = __importDefault(require("./HxSharingMessageAction"));
var HxOneRMContent_1 = __importDefault(require("./HxOneRMContent"));
var HxSuggestionLayoutData_1 = __importDefault(require("./HxSuggestionLayoutData"));
var HxSearchInstrumentationData_1 = __importDefault(require("./HxSearchInstrumentationData"));
var HxSharingPermissionsRequestsData_1 = __importDefault(require("./HxSharingPermissionsRequestsData"));
var HxSharingPermissionInfoRequestsData_1 = __importDefault(require("./HxSharingPermissionInfoRequestsData"));
var HxMailToastGroup_1 = __importDefault(require("./HxMailToastGroup"));
var HxCalendarSharingDetailLevel_1 = __importDefault(require("./HxCalendarSharingDetailLevel"));
var HxCalendarSharingPermission_1 = __importDefault(require("./HxCalendarSharingPermission"));
var HxInboxRule_1 = __importDefault(require("./HxInboxRule"));
var HxRuleAction_1 = __importDefault(require("./HxRuleAction"));
var HxRuleCondition_1 = __importDefault(require("./HxRuleCondition"));
var HxSearchResultAppointment_1 = __importDefault(require("./HxSearchResultAppointment"));
var HxSearchResultAppointmentsBatch_1 = __importDefault(require("./HxSearchResultAppointmentsBatch"));
var HxLocalEvent_1 = __importDefault(require("./HxLocalEvent"));
var HxGlobalEasPolicies_1 = __importDefault(require("./HxGlobalEasPolicies"));
var HxFirstSync_1 = __importDefault(require("./HxFirstSync"));
var HxRemappedServerId_1 = __importDefault(require("./HxRemappedServerId"));
var HxClientExtensionNotificationMessage_1 = __importDefault(require("./HxClientExtensionNotificationMessage"));
var HxClientExtensionNotification_1 = __importDefault(require("./HxClientExtensionNotification"));
var HxContactImAddress_1 = __importDefault(require("./HxContactImAddress"));
var HxMeetingHeader_1 = __importDefault(require("./HxMeetingHeader"));
var HxIconCatalog_1 = __importDefault(require("./HxIconCatalog"));
var HxIconData_1 = __importDefault(require("./HxIconData"));
var HxFavoriteItem_1 = __importDefault(require("./HxFavoriteItem"));
var HxAttachmentHeader_1 = __importDefault(require("./HxAttachmentHeader"));
var HxGroup_1 = __importDefault(require("./HxGroup"));
var HxGroupDetail_1 = __importDefault(require("./HxGroupDetail"));
var HxGroupResource_1 = __importDefault(require("./HxGroupResource"));
var HxGroupSettings_1 = __importDefault(require("./HxGroupSettings"));
var HxGroupDataClassification_1 = __importDefault(require("./HxGroupDataClassification"));
var HxGroupMember_1 = __importDefault(require("./HxGroupMember"));
var HxTeachingCalloutDataCatalog_1 = __importDefault(require("./HxTeachingCalloutDataCatalog"));
var HxTeachingCalloutData_1 = __importDefault(require("./HxTeachingCalloutData"));
var HxReminder_1 = __importDefault(require("./HxReminder"));
var HxFavoritePerson_1 = __importDefault(require("./HxFavoritePerson"));
var HxMention_1 = __importDefault(require("./HxMention"));
var HxMipLabelDisplayName_1 = __importDefault(require("./HxMipLabelDisplayName"));
var HxMipLabel_1 = __importDefault(require("./HxMipLabel"));
var HxMipLabelTooltip_1 = __importDefault(require("./HxMipLabelTooltip"));
var HxInboxRuleAddress_1 = __importDefault(require("./HxInboxRuleAddress"));
var HxTailoredExperience_1 = __importDefault(require("./HxTailoredExperience"));
var HxAttachmentSearchSession_1 = __importDefault(require("./HxAttachmentSearchSession"));
var HxAccountAttachmentSearchSession_1 = __importDefault(require("./HxAccountAttachmentSearchSession"));
var HxAttachmentHeaderSearchData_1 = __importDefault(require("./HxAttachmentHeaderSearchData"));
var HxSearchSession_1 = __importDefault(require("./HxSearchSession"));
var HxMailSearchSession_1 = __importDefault(require("./HxMailSearchSession"));
var HxAccountMailSearchSession_1 = __importDefault(require("./HxAccountMailSearchSession"));
var HxSuggestionSearchSession_1 = __importDefault(require("./HxSuggestionSearchSession"));
var HxAccountSuggestionSearchSession_1 = __importDefault(require("./HxAccountSuggestionSearchSession"));
var HxMessageHeaderSearchData_1 = __importDefault(require("./HxMessageHeaderSearchData"));
var HxCalendarSearchSession_1 = __importDefault(require("./HxCalendarSearchSession"));
var HxAccountCalendarSearchSession_1 = __importDefault(require("./HxAccountCalendarSearchSession"));
var HxAppointmentHeaderSearchData_1 = __importDefault(require("./HxAppointmentHeaderSearchData"));
var HxTimeSlotAvailabilityData_1 = __importDefault(require("./HxTimeSlotAvailabilityData"));
var HxLocationTimeEntityData_1 = __importDefault(require("./HxLocationTimeEntityData"));
var HxContactEmailIndexEntry_1 = __importDefault(require("./HxContactEmailIndexEntry"));
var HxRemoteMailbox_1 = __importDefault(require("./HxRemoteMailbox"));
var HxPresence_1 = __importDefault(require("./HxPresence"));
var HxGroupMipLabel_1 = __importDefault(require("./HxGroupMipLabel"));
var HxBlockedSenderAndDomain_1 = __importDefault(require("./HxBlockedSenderAndDomain"));
var HxDelegateUser_1 = __importDefault(require("./HxDelegateUser"));
var HxInferredLocation_1 = __importDefault(require("./HxInferredLocation"));
var HxAddIn_1 = __importDefault(require("./HxAddIn"));
var HxPeopleSearchSession_1 = __importDefault(require("./HxPeopleSearchSession"));
var HxAccountPeopleSearchSession_1 = __importDefault(require("./HxAccountPeopleSearchSession"));
var HxRecentlyUsedView_1 = __importDefault(require("./HxRecentlyUsedView"));
var HxInitializationTriggerForLocalClassification_1 = __importDefault(require("./HxInitializationTriggerForLocalClassification"));
var HxAnswerSearchSession_1 = __importDefault(require("./HxAnswerSearchSession"));
var HxAccountAnswerSearchSession_1 = __importDefault(require("./HxAccountAnswerSearchSession"));
var HxTopSearchSession_1 = __importDefault(require("./HxTopSearchSession"));
var HxStorageHealthStatistics_1 = __importDefault(require("./HxStorageHealthStatistics"));
var HxSpeedyMeetingSetting_1 = __importDefault(require("./HxSpeedyMeetingSetting"));
var HxToDoAccountData_1 = __importDefault(require("./HxToDoAccountData"));
var HxToDoTask_1 = __importDefault(require("./HxToDoTask"));
var HxAccountTopSearchSession_1 = __importDefault(require("./HxAccountTopSearchSession"));
var HxWidgetData_1 = __importDefault(require("./HxWidgetData"));
var HxWidgetMessage_1 = __importDefault(require("./HxWidgetMessage"));
var HxSearchableItem_1 = __importDefault(require("./HxSearchableItem"));
var HxContactCertificate_1 = __importDefault(require("./HxContactCertificate"));
var HxContactCategoryInfo_1 = __importDefault(require("./HxContactCategoryInfo"));
var HxReactionType_1 = __importDefault(require("./HxReactionType"));
var HxReactionAuthor_1 = __importDefault(require("./HxReactionAuthor"));
var HxReaction_1 = __importDefault(require("./HxReaction"));
var HxRecipientSearchSession_1 = __importDefault(require("./HxRecipientSearchSession"));
var HxAccountRecipientSearchSession_1 = __importDefault(require("./HxAccountRecipientSearchSession"));
var HxFileSearchSession_1 = __importDefault(require("./HxFileSearchSession"));
var HxAccountFileSearchSession_1 = __importDefault(require("./HxAccountFileSearchSession"));
var HxFileHeader_1 = __importDefault(require("./HxFileHeader"));
var HxFileHeaderSearchData_1 = __importDefault(require("./HxFileHeaderSearchData"));
var HxAadLogoData_1 = __importDefault(require("./HxAadLogoData"));
var HxPackageSizeStatistics_1 = __importDefault(require("./HxPackageSizeStatistics"));
var HxPreviewICSResult_1 = __importDefault(require("./HxPreviewICSResult"));
var HxLdapServerSetting_1 = __importDefault(require("./HxLdapServerSetting"));
var HxPreviewVCFResult_1 = __importDefault(require("./HxPreviewVCFResult"));
var HxAccountContactSearchSession_1 = __importDefault(require("./HxAccountContactSearchSession"));
var HxUnifiedRecentlyUsedView_1 = __importDefault(require("./HxUnifiedRecentlyUsedView"));
var HxActivityFeedItem_1 = __importDefault(require("./HxActivityFeedItem"));
var HxMailSubscription_1 = __importDefault(require("./HxMailSubscription"));
var HxBestMatchSuggestion_1 = __importDefault(require("./HxBestMatchSuggestion"));
var HxOnlineArchiveMailbox_1 = __importDefault(require("./HxOnlineArchiveMailbox"));
var HxO365SubscriptionDetails_1 = __importDefault(require("./HxO365SubscriptionDetails"));
var HxUserSettings_1 = __importDefault(require("./HxUserSettings"));
var HxLocalEventsLocation_1 = __importDefault(require("./HxLocalEventsLocation"));
var HxWeatherLocation_1 = __importDefault(require("./HxWeatherLocation"));
var HxObjectSerializer = /** @class */ (function () {
    function HxObjectSerializer() {
    }
    HxObjectSerializer.deserializeJsonObject = function (jsObject, activeSet) {
        var objectId = jsObject[0];
        var objectType = jsObject[1];
        var storageSequenceNumber = jsObject[2];
        var obj = jsObject[3];
        switch (objectType) {
            case 67:
                return new HxRoot_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 69:
                return new HxError_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 71:
                return new HxPreferences_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 72:
                return new HxUnifiedMailbox_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 73:
                return new HxAccount_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 74:
                return new HxMailAccountData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 75:
                return new HxCalendarAccountData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 77:
                return new HxView_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 79:
                return new HxConversationHeader_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 84:
                return new HxSuggestion_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 85:
                return new HxPerson_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 93:
                return new HxMeetingRequest_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 94:
                return new HxMeetingResponse_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 95:
                return new HxMeetingCancellation_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 97:
                return new HxTimeZoneSystemEvent_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 99:
                return new HxCalendarRoot_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 100:
                return new HxWeatherData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 102:
                return new HxPhotoData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 103:
                return new HxCalendarGroupData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 104:
                return new HxCalendarData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 105:
                return new HxCategoryData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 107:
                return new HxAppointmentHeader_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 108:
                return new HxAppointmentBody_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 113:
                return new HxMeetingAttendee_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 124:
                return new HxRightsManagementLicense_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 125:
                return new HxSmimeInformation_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 128:
                return new HxCalendarAttendeeCollectionPair_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 135:
                return new HxRmsTemplate_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 137:
                return new HxPhotoInfo_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 144:
                return new HxWeatherUpdates_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 158:
                return new HxCalendarCatalog_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 159:
                return new HxCalendarCatalogItem_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 161:
                return new HxGlobalApplicationSettings_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 170:
                return new HxTileNotification_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 171:
                return new HxNotificationData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 173:
                return new HxMailToastData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 175:
                return new HxCalendarNotificationData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 189:
                return new HxHolidayCatalog_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 190:
                return new HxHolidayCatalogData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 191:
                return new HxConversation_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 194:
                return new HxViewLink_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 196:
                return new HxRichContent_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 201:
                return new HxMessageHeader_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 202:
                return new HxMessageData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 210:
                return new HxRecipient_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 224:
                return new HxContact_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 225:
                return new HxContactAddress_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 227:
                return new HxContactDate_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 228:
                return new HxContactPhone_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 229:
                return new HxContactSignificantOther_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 235:
                return new HxLocationEntityData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 236:
                return new HxLocationSuggestionsData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 239:
                return new HxContactAccountData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 240:
                return new HxContactSyncState_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 244:
                return new HxContactSearchData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 248:
                return new HxEasPolicies_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 252:
                return new HxContactUrl_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 254:
                return new HxMeetingRequestOccurrenceInfo_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 256:
                return new HxCatalogDataProvider_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 271:
                return new HxSharingMessageAction_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 274:
                return new HxOneRMContent_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 276:
                return new HxSuggestionLayoutData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 288:
                return new HxSearchInstrumentationData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 292:
                return new HxSharingPermissionsRequestsData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 293:
                return new HxSharingPermissionInfoRequestsData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 299:
                return new HxMailToastGroup_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 305:
                return new HxCalendarSharingDetailLevel_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 306:
                return new HxCalendarSharingPermission_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 313:
                return new HxInboxRule_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 314:
                return new HxRuleAction_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 315:
                return new HxRuleCondition_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 320:
                return new HxSearchResultAppointment_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 321:
                return new HxSearchResultAppointmentsBatch_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 331:
                return new HxLocalEvent_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 332:
                return new HxGlobalEasPolicies_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 333:
                return new HxFirstSync_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 338:
                return new HxRemappedServerId_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 341:
                return new HxClientExtensionNotificationMessage_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 342:
                return new HxClientExtensionNotification_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 344:
                return new HxContactImAddress_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 349:
                return new HxMeetingHeader_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 353:
                return new HxIconCatalog_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 354:
                return new HxIconData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 356:
                return new HxFavoriteItem_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 362:
                return new HxAttachmentHeader_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 370:
                return new HxGroup_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 372:
                return new HxGroupDetail_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 373:
                return new HxGroupResource_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 376:
                return new HxGroupSettings_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 377:
                return new HxGroupDataClassification_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 378:
                return new HxGroupMember_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 381:
                return new HxTeachingCalloutDataCatalog_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 382:
                return new HxTeachingCalloutData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 385:
                return new HxReminder_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 389:
                return new HxFavoritePerson_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 392:
                return new HxMention_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 396:
                return new HxMipLabelDisplayName_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 397:
                return new HxMipLabel_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 399:
                return new HxMipLabelTooltip_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 403:
                return new HxInboxRuleAddress_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 406:
                return new HxTailoredExperience_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 418:
                return new HxAttachmentSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 419:
                return new HxAccountAttachmentSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 420:
                return new HxAttachmentHeaderSearchData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 428:
                return new HxSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 429:
                return new HxMailSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 430:
                return new HxAccountMailSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 431:
                return new HxSuggestionSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 432:
                return new HxAccountSuggestionSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 433:
                return new HxMessageHeaderSearchData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 449:
                return new HxCalendarSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 450:
                return new HxAccountCalendarSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 451:
                return new HxAppointmentHeaderSearchData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 454:
                return new HxTimeSlotAvailabilityData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 455:
                return new HxLocationTimeEntityData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 457:
                return new HxContactEmailIndexEntry_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 459:
                return new HxRemoteMailbox_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 463:
                return new HxPresence_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 466:
                return new HxGroupMipLabel_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 468:
                return new HxBlockedSenderAndDomain_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 470:
                return new HxDelegateUser_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 473:
                return new HxInferredLocation_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 475:
                return new HxAddIn_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 480:
                return new HxPeopleSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 481:
                return new HxAccountPeopleSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 485:
                return new HxRecentlyUsedView_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 486:
                return new HxInitializationTriggerForLocalClassification_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 489:
                return new HxAnswerSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 490:
                return new HxAccountAnswerSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 496:
                return new HxTopSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 497:
                return new HxStorageHealthStatistics_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 508:
                return new HxSpeedyMeetingSetting_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 510:
                return new HxToDoAccountData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 511:
                return new HxToDoTask_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 514:
                return new HxAccountTopSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 521:
                return new HxWidgetData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 522:
                return new HxWidgetMessage_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 527:
                return new HxSearchableItem_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 529:
                return new HxContactCertificate_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 531:
                return new HxContactCategoryInfo_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 533:
                return new HxReactionType_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 536:
                return new HxReactionAuthor_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 537:
                return new HxReaction_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 542:
                return new HxRecipientSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 543:
                return new HxAccountRecipientSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 548:
                return new HxFileSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 549:
                return new HxAccountFileSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 550:
                return new HxFileHeader_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 551:
                return new HxFileHeaderSearchData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 552:
                return new HxAadLogoData_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 553:
                return new HxPackageSizeStatistics_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 556:
                return new HxPreviewICSResult_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 558:
                return new HxLdapServerSetting_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 561:
                return new HxPreviewVCFResult_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 562:
                return new HxAccountContactSearchSession_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 564:
                return new HxUnifiedRecentlyUsedView_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 568:
                return new HxActivityFeedItem_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 570:
                return new HxMailSubscription_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 573:
                return new HxBestMatchSuggestion_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 574:
                return new HxOnlineArchiveMailbox_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 577:
                return new HxO365SubscriptionDetails_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 579:
                return new HxUserSettings_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 580:
                return new HxLocalEventsLocation_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            case 581:
                return new HxWeatherLocation_1.default(new HxObjectID_1.default(objectId), storageSequenceNumber, obj, activeSet);
            default:
                // NotReached();
                throw new RangeError("Unexpected object type " + objectType);
        }
    };
    return HxObjectSerializer;
}());
exports.default = HxObjectSerializer;
